import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Container, Typography } from '@material-ui/core'
import { lighten } from '@material-ui/core/styles'
import { makeStyles, useTheme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => {
  return {
    container: {
      background: lighten(theme.palette.info.main, 0.9),
    },
  }
})

const Banner = ({ appCycle }: { appCycle: number }) => {
  const styles = useStyles()
  const theme = useTheme()
  return (
    <Box mt={3}>
      <Container maxWidth="lg">
        <Box
          className={styles.container}
          padding={2}
        >
          <Box
            display="flex"
            alignItems="center"
          >
            <Box mr={2}>
              <FontAwesomeIcon
                size="2x"
                icon={faInfoCircle as IconProp}
                color={theme.palette.info.main}
              />
            </Box>
            <Typography variant="caption">
              This page is showing results from the {appCycle - 1}-{appCycle} application cycle. Starting August 1, this
              page will begin showing results from the {appCycle}-{appCycle + 1} cycle.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default Banner
